import React from 'react';
import {WithRouterProps} from 'react-router';

import albeyWaving from 'client/assets/characters/Albey/albey_poses_Waving.svg';
import {history} from 'client/history';
import JoinClassroomForm from 'client/Classrooms/JoinClassroom/JoinClassroomForm';
import JoinClassroomInput from 'client/Classrooms/JoinClassroom/JoinClassroomInput';
import JoinClassroomSubmitButton from 'client/Classrooms/JoinClassroom/JoinClassroomSubmitButton';
import {Text} from '@albert-io/atomic';
import useOnClassroomEnrollment from './hooks/useOnClassroomEnrollment';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function Welcome({params}: WithRouterProps) {
  const classroomId: string | undefined = params.classroomId;
  const onClassroomEnrollment = useOnClassroomEnrollment(classroomId);

  const showJoinClassModal = useStudentDashboard((state) => state.showJoinClassModal);

  function onEnrollSuccess() {
    history.replace('/home/assignments');
    onClassroomEnrollment();
  }

  return (
    <div className='flex flex-col items-center gap-x14 p-x5 m:flex-row m:justify-center'>
      <div className='w-[250px]'>
        <Text className='mb-x3 block font-black' size='xl'>
          Welcome to Albert!
        </Text>
        <JoinClassroomForm isNewStudentDashboard onEnrollSuccess={onEnrollSuccess}>
          <JoinClassroomInput className='mb-x1-half' hideLabel inert={showJoinClassModal} />
          <JoinClassroomSubmitButton className='w-full rounded-full' inert={showJoinClassModal} />
        </JoinClassroomForm>
      </div>
      <img alt='Illustration of Albey waving' className='w-x10 m:w-x20' src={albeyWaving} />
    </div>
  );
}
